
function WorkInProgress() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 32 32"
      fill="none"
    >
      <g clip-path="url(#clip0_2774_2244)">
        <path
          d="M14.7111 30.0237C6.96606 30.0237 0.6875 23.7451 0.6875 16.0001C0.6875 8.25513 6.96606 1.97656 14.7111 1.97656C22.4561 1.97656 28.7346 8.25513 28.7346 16.0001V17.7093"
          stroke="#1E9AFF"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M31.312 15.1377L28.7341 17.7156L26.1562 15.1377"
          stroke="#1E9AFF"
          stroke-width="1.5"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <circle cx="28" cy="22" r="1" fill="#1E9AFF" />
        <circle cx="26" cy="26" r="1" fill="#1E9AFF" />
        <circle cx="22.5" cy="29" r="1" fill="#1E9AFF" />
        <circle cx="18" cy="30" r="1" fill="#1E9AFF" />
        <path
          d="M24 16C24 14.22 23.4722 12.4799 22.4832 10.9999C21.4943 9.51983 20.0887 8.36627 18.4442 7.68508C16.7996 7.0039 14.99 6.82567 13.2442 7.17293C11.4984 7.5202 9.89471 8.37737 8.63604 9.63604C7.37737 10.8947 6.5202 12.4984 6.17293 14.2442C5.82567 15.99 6.0039 17.7996 6.68508 19.4442C7.36627 21.0887 8.51983 22.4943 9.99987 23.4832C11.4799 24.4722 13.22 25 15 25V16H24Z"
          fill="#1E9AFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_2774_2244">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default WorkInProgress;
